import { definePlayerFeature } from "../../feature.js";
import { listen, serializeTimeRanges } from "@videojs/utils/dom";
import { isMediaBufferCapable } from "@videojs/media";
//#region src/dom/store/features/buffer.ts
const bufferFeature = definePlayerFeature({
	name: "buffer",
	state: () => ({
		buffered: [],
		seekable: []
	}),
	attach({ target, signal, set }) {
		const { media } = target;
		if (!isMediaBufferCapable(media)) return;
		const sync = () => set({
			buffered: serializeTimeRanges(media.buffered),
			seekable: serializeTimeRanges(media.seekable)
		});
		sync();
		listen(media, "loadedmetadata", sync, { signal });
		listen(media, "durationchange", sync, { signal });
		listen(media, "progress", sync, { signal });
		listen(media, "emptied", sync, { signal });
	}
});
//#endregion
export { bufferFeature };

//# sourceMappingURL=buffer.js.map